import React, { Fragment } from 'react';
import { Dispatch } from 'redux';
import { connect } from 'dva';
import {
  getOnChange,
  isNameChangedToggle,
  trimOnBlur,
} from '../../../helpers/handlers';
import NameChangeRadio from '../../shared/NameChangeRadio/NameChangeRadio';
import ChangeFIO from '../../shared/ChangeFIO/ChangeFIO';
import { CHILD } from '../../../models/child';

function ChildNameChange({
  child,
  onChange,
  isNameChangedToggle,
  onBlur,
}): JSX.Element | null {
  const { changeName, address, ...ChangeFIOFields } = child;
  return (
    <Fragment>
      <NameChangeRadio
        model={CHILD}
        changeName={changeName}
        isNameChangedToggle={isNameChangedToggle}
      />
      <ChangeFIO
        changeName={changeName}
        onChange={onChange}
        onBlur={onBlur}
        {...ChangeFIOFields}
      />
    </Fragment>
  );
}

const mapStateToProps = ({ child }) => ({ child });
const mapDispatchToProps = (dispatch: Dispatch) => ({
  onChange: getOnChange(CHILD, dispatch),
  onBlur: trimOnBlur(CHILD, dispatch),
  isNameChangedToggle: isNameChangedToggle(CHILD, dispatch),
});

const ChildNameChangeContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ChildNameChange);

export { ChildNameChangeContainer as ChildNameChange };
